export default "__VITE_ASSET__9NAA5Ilm__"